<template>
  <b-modal ref="excel-modal" id="excel-modal" body-class="excel-modal-body" size="sm" hide-footer no-close-on-backdrop static>
    <template slot="modal-header">
      <h4 class="modal-title">Snel je panelen invoeren?</h4>
      <button type="button" aria-label="Close" @click="hideModal" class="close">
        <font-awesome-icon class="font-awesome-icon" icon="times-circle"/>
      </button>
    </template>
    <template slot="default">
      <div class="col-md-13 excel-info background">
        <div class="mb-3">
          Vul een <a href="/excel/Leeg_invoerformulier_configurator.xlsx" target="_blank" class="link">leeg invoerformulier</a> in en upload deze hieronder. Je invoer is direct ingevuld.
        </div>

        <a href="/excel/Voorbeeldbestand_configurator.xlsx" target="_blank" class="link">
          <font-awesome-icon class="font-awesome-icon" icon="arrow-circle-down"/>
          Download een voorbeeldbestand
        </a>
      </div>

      <div v-if="dragDropCapable" class="excel-upload" :class="[excelUploadBusy ? 'excel-upload-busy' : '']">
        <div class="col-md-13">
          <div :class="['upload-drop-zone', dragging ? 'drop-zone-active' : '']" @dragover="dragging=true" @drop="dragging=false" @dragleave="dragging=false" ref="excel_drop_zone">
            Sleep hier een Excel-bestand naar toe
          </div>
        </div>

        <div class="col-md-13">
          <div class="row manual-upload-link justify-content-center mb-2">
            <input type="file" :disabled="excelUploadBusy" v-on:change="selectFile()" name="excel_file" id="excel_file" ref="excel_file" style="display:none">
            <label for="excel_file" class="link">
              <font-awesome-icon class="font-awesome-icon" icon="folder-open"/>
              Kies een Excel-bestand...
            </label>
          </div>
        </div>
      </div>

      <div v-if="excel_file" class="col-md-13 excel-info-bottom background">
        {{ excel_file.name }}

        <b-progress :value="bar.value" :variant="bar.variant" height="10px" animated></b-progress>

        <div v-for="(error, index) in errors" :key="index" class="col-md-13 mt-2">
          <span class="text-muted" v-html="error"></span>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
  import { UPLOAD_EXCEL } from  '../../../store/types'

  export default {
    data() {
      return {
        bar: { value: 0, variant: 'success' },
        errors: [],
        drag_drop_capable: false,
        dragging: false,
        excel_file: null
      }
    },
    computed: {
      excelUploadStatus() {
        return this.$store.getters.excelUploadStatus
      },
      excelUploadBusy() {
        return this.$store.getters.excelUploadBusy
      },
      excelUploadProgress() {
        return this.$store.getters.excelUploadProgress
      },
      dragDropCapable() {
        // Create a test element to see if certain events are present that let us do drag and drop.
        const div = document.createElement('div')
        /*
          Check to see if the `draggable` event is in the element
          or the `ondragstart` and `ondrop` events are in the element. If
          they are, then we have what we need for dragging and dropping files.

          We also check to see if the window has `FormData` and `FileReader` objects
          present so we can do our AJAX uploading
        */
        return ((('draggable' in div) || ('ondragstart' in div && 'ondrop' in div)) && 'FormData' in window && 'FileReader' in window)
      }
    },
    watch: {
      excelUploadProgress(val) {
        this.bar.value = val
      },
      excelUploadStatus(val) {
        if (val) {
          if (val.errors) {
            this.bar.variant = 'danger'
            this.errors = val.errors
          }
        }
      }
    },
    methods: {
      showModal() {
        this.$refs['excel-modal'].show()
      },
      hideModal() {
        this.$refs['excel-modal'].hide()
      },
      selectFile() {
        this.excel_file = this.$refs.excel_file.files[0]
        this.handleFileUpload()
      },
      handleFileUpload() {
        this.errors = []

        this.bar.value = 0
        this.bar.variant = 'success'

        this.$store.dispatch(UPLOAD_EXCEL, this.excel_file).then(() => {
          if (!this.errors.length) {
            this.hideModal()
            this.excel_file = null
          }
        })
      }
    },
    mounted() {
      // this.dragAndDropCapable = this.determineDragAndDropCapable()
      const dropZone = this.$refs.excel_drop_zone

      // If drag and drop capable, then we continue to bind events to our elements.
      if (this.dragDropCapable) {
        // Listen to all of the drag events and bind an event listener to each for the fileform.
        ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(function(evt) {
          /*
            For each event add an event listener that prevents the default action
            (opening the file in the browser) and stop the propagation of the event (so
            no other elements open the file in the browser)
          */
          dropZone.addEventListener(evt, function(e) {
            e.preventDefault()
            e.stopPropagation()
          })
        })

        // Add an event listener for drop to the form
        dropZone.addEventListener('drop', function(e) {
          this.excel_file = e.dataTransfer.files[0]
          this.handleFileUpload()
        }
          .bind(this))
      }
    }
  }
</script>

<style lang="scss" scoped>
  .excel-upload-busy {
    opacity: 0.5;
  }

  .excel-upload {
    border-top: 1px solid lightgrey;
    background: white;
    margin-left: -15px;
    margin-right: -15px;
    margin-bottom: -22px;
    padding-top: 5px;
  }

  .upload-drop-zone {
    height: 100px;
    border-width: 2px;
    color: #ccc;
    border-style: dashed;
    border-color: #ccc;
    line-height: 100px;
    text-align: center;
    margin: 10px 5px 20px;
  }

  .upload-drop-zone.drop {
    color: #222;
    border-color: #222;
  }

  .excel-modal-body {
    padding: 0 !important;
  }

  .drop-zone-active {
    color: #222;
    border-color: #222;
  }

  .manual-upload-link {
    border-bottom: 1px solid lightgrey;
  }

  .excel-info {
    padding-top: 10px;
    padding-bottom: 20px;
    font-size: 1.1em;
    text-align: left;
  }

  .link {
    text-transform: none;
  }

  .excel-info-bottom {
    top: 15px;
    margin-bottom: 15px;
    margin-top: 20px;
    text-align: left;
  }

  .progress {
    margin-top: 10px;
  }
</style>
